<template>
  <el-select
    :value="value == null ? '' : value"
    class="chart-font-family-select"
    :class="selectClass"
    :style="selectStyle"
    :placeholder="placeholder"
    :filterable="filterable"
    :clearable="clearable"
    @input="$emit('input', $event)">
    <el-option-group
      v-for="(group, gi) in optionGroups"
      :key="'chart-ffg-' + gi + '-' + group.label"
      :label="group.label">
      <el-option
        v-for="item in group.options"
        :key="'chart-ffo-' + group.label + '-' + (item.value === '' ? 'default' : item.value)"
        :label="item.label"
        :value="item.value" />
    </el-option-group>
  </el-select>
</template>

<script>
import { FONT_FAMILY_OPTION_GROUPS } from '@/utils/chartTitlePresets'

/**
 * 大屏统一字体下拉（数据源自 chartTitlePresets.js）
 */
export default {
  name: 'ChartFontFamilySelect',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    /** 数字为 px，或任意 CSS width 字符串 */
    width: {
      type: [String, Number],
      default: 220,
    },
    placeholder: {
      type: String,
      default: '默认',
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    selectClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    optionGroups () {
      return FONT_FAMILY_OPTION_GROUPS
    },
    selectStyle () {
      const w = typeof this.width === 'number' ? `${this.width}px` : this.width
      return { width: w }
    },
  },
}
</script>
